/* Elya — compte à rebours de l'offre : cycle de 4 JOURS, reset à minuit (heure de Paris)
   tous les 4 jours (demande Max 01/11 ; 1er cycle 01/11 -> fin nuit du 04 au 05/11).
   Version « fin fixe 30/11 » sauvegardée dans ~/brands/elya/backups/timer-cycle-4j-2026-11-01/. Aligné sur la date de Paris -> insensible au changement d'heure.
   Robuste aux re-rendus du thème : re-cherche les éléments à chaque tick. */
(function () {
  var fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', hour12: false,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit' });
  var CYCLE = 4;                                           // longueur du cycle, en jours
  var ANCHOR = Math.floor(Date.UTC(2026, 10, 1) / 86400000); // 01/11/2026 = 1er jour d'un cycle
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var els = document.querySelectorAll('[data-elya-countdown]');
    if (!els.length) return;
    var p = {}, parts = fmt.formatToParts(new Date());
    for (var i = 0; i < parts.length; i++) p[parts[i].type] = parts[i].value;
    var dayNum = Math.floor(Date.UTC(parseInt(p.year, 10), parseInt(p.month, 10) - 1, parseInt(p.day, 10)) / 86400000);
    var idx = ((dayNum - ANCHOR) % CYCLE + CYCLE) % CYCLE;  // 0 à 3
    var secToday = parseInt(p.hour, 10) % 24 * 3600 + parseInt(p.minute, 10) * 60 + parseInt(p.second, 10);
    var rem = (CYCLE - 1 - idx) * 86400 + (86400 - secToday);
    if (rem >= CYCLE * 86400) rem = CYCLE * 86400 - 1;
    var dd = Math.floor(rem / 86400), hh = Math.floor((rem % 86400) / 3600),
        mm = Math.floor((rem % 3600) / 60), ss = rem % 60;
    for (var j = 0; j < els.length; j++) {
      var letter = els[j].getAttribute('data-day-letter') || 'j';
      var txt = pad(dd) + letter + ' ' + pad(hh) + 'h ' + pad(mm) + 'm ' + pad(ss) + 's';
      if (els[j].textContent !== txt) els[j].textContent = txt;
    }
  }
  tick();
  setInterval(tick, 1000);
})();
